<!-- 部门管理 -->
<template>
  <div class="department-manage">
    <div class="table-header">
      <a-form :layout="'horizontal'" class="page-search" :colon="true">
        <a-row :gutter="20">
          <a-col span="6">
            <a-form-item
              label="部门名称"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <LenovoSelectModule
                :reset="true"
                placeholder="请输入"
                v-model="params.deptName"
                apiType="getPubDeptName"
                modelKey="name"
                :paramsListObj="{ name: 'name', id: 'id' }"
              />
            </a-form-item>
          </a-col>

          <a-col span="6">
            <a-form-item
              label="上级部门"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <InputText
                placeholder="请输入"
                v-model="params.parentName"
                allowClear
              />
            </a-form-item>
          </a-col>

          <a-col span="6">
            <a-form-item
              label="状态"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <SelectModule
                v-model="params.dataStatus"
                apiType="getDictDataByCode"
                :apiParams="{ dictCode: 'dept_status' }"
              />
            </a-form-item>
          </a-col>

          <a-col class="flag" span="6">
            <a-button @click="onReset"
              ><a-icon type="reload" style="color: #585d68" />重置</a-button
            >
            <a-button type="primary" @click="handleSearch"
              ><IconSvg iconData="search" />查询</a-button
            >
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-concent">
      <div class="concent-buts">
        <a-button type="primary" @click="handleTableRow(true)"
          ><a-icon type="plus" />新增</a-button
        >
      </div>

      <div class="flex-card-component">
        <div class="left-content">
          <div class="inner-content">
            <div class="organ-tree">
              <a-tree
                v-if="treeData.length > 0"
                ref="tree"
                default-expand-all
                :tree-data="treeData"
                @select="onCheck"
                :checkStrictly="false"
                :selected-keys="checkValue"
              />
            </div>
          </div>
        </div>

        <div class="right-content">
          <div class="content">
            <TableList
              :columns="columns"
              :tableData="tableData"
              :loading="loading"
              :pageInfo="pageBean"
              @getList="changePage"
              :scroll="{ x: 1200, y: 'calc(100vh - 346px)' }"
            >
              <div slot="action" slot-scope="record" class="columns-action">
                <a-button
                  type="link"
                  @click="handleTableRow(true, record.scope)"
                  >编辑</a-button
                >
                <a-button type="link" @click="showSendConfirm(record.scope)">{{
                  record.scope.dataStatus == "0" ? "启用" : "停用"
                }}</a-button>
                <a-button type="link" @click="showDeletConfirm(record.scope)"
                  >删除</a-button
                >
              </div>
            </TableList>
          </div>
        </div>
      </div>
    </div>

    <AddEdit
      :modalFlag="modalFlag"
      :modalData="modalData"
      @handleFlag="handleTableRow"
    />
  </div>
</template>

<script>
import InputText from "@/components/form/InputText"; // 输入框组件
import SelectModule from "@/components/form/SelectModule"; // 下拉组件
import TableList from "@/components/table/TableList"; // 表格组件
import LenovoSelectModule from "@/components/form/LenovoSelectModule"; // 联想下拉
import API from "@/api/sysManage.js"; // 请求接口
import COMAPI from "@/api/common.js"; // 公共请求接口
import AddEdit from "./components/AddEdit.vue";
import "./index.less";

export default {
  components: {
    LenovoSelectModule,
    InputText,
    SelectModule,
    TableList,
    AddEdit,
  },
  computed: {
    columns() {
      const columns = [
        {
          title: "序号",
          dataIndex: "key",
          key: "key",
          width: 100,
          align: "center",
          fixed: "left",
          ellipsis: true,
          customRender: (text, row, index) => {
            return (
              (this.pageBean.pageNum - 1) * this.pageBean.pageSize + index + 1
            );
          },
        },
        {
          title: "部门名称",
          dataIndex: "deptName",
          key: "deptName",
          ellipsis: true,
          scopedSlots: { customRender: "deptName" },
        },
        {
          title: "上级部门",
          dataIndex: "parentName",
          key: "parentName",
          ellipsis: true,
          width: 160,
          scopedSlots: { customRender: "parentName" },
        },
        {
          title: "联系人",
          dataIndex: "deptContactName",
          key: "deptContactName",
          ellipsis: true,
          scopedSlots: { customRender: "deptContactName" },
        },
        {
          title: "联系电话",
          dataIndex: "deptContactPhone",
          key: "deptContactPhone",
          ellipsis: true,
          scopedSlots: { customRender: "deptContactPhone" },
        },
        {
          title: "地址",
          dataIndex: "deptAddr",
          key: "deptAddr",
          ellipsis: true,
          width: 80,
          scopedSlots: { customRender: "deptAddr" },
        },
        {
          title: "状态",
          dataIndex: "dataStatusDesc",
          key: "dataStatusDesc",
          width: 80,
          ellipsis: true,
        },
        {
          title: "操作",
          dataIndex: "actions",
          key: "actions",
          width: 170,
          align: "center",
          fixed: "right",
          scopedSlots: { customRender: "action" },
        },
      ];
      return columns;
    },
  },
  data() {
    return {
      loading: false, // 是否加载
      pageBean: {
        // 自定义分页
        pageNum: 1, // 当前页数
        pageSize: 10, // 每页条数
        total: 0, // 数据总数
      },
      params: {
        deptName: "",
        parentName: "",
        dataStatus: "",
      },
      deptName: "",
      checkValue: [], // 左侧菜单选中的数据
      tableData: [], // 列表数据
      formItemLayout: {
        labelCol: {
          span: 6,
        },
        wrapperCol: {
          span: 18,
        },
      },
      modalFlag: false, // 弹层状态
      modalData: {}, // 表格选中数据
      treeData: [], // 权限树数据
    };
  },
  mounted() {
    this.getMenuInit();
  },
  methods: {
    // 查询
    handleSearch() {
      this.getData(1);
    },
    // 获取列表数据
    getData(pageNum) {
      this.loading = true;
      let params = {
        data: {
          pageBean: {
            pageNum: pageNum,
            pageSize: this.pageBean.pageSize,
          },
          params: {
            ...this.params,
            deptName: this.deptName ? this.deptName : this.params.deptName,
          },
        },
      };
      API.pagePubDeptInfo(params, (callback) => {
        this.loading = false;
        let list = []; // 数据
        if (callback.status == "S" && callback.data) {
          const backData = callback.data;
          const pageBean = { ...this.pageBean };
          pageBean.total = backData.total || 0;
          pageBean.pageNum = pageNum || 1;
          this.pageBean = pageBean;

          if (Array.isArray(backData.list) && backData.list.length > 0) {
            backData.list.map((item, index) => {
              // item.key = item.id;
              item.key = index;
            });
            list = backData.list;
          }
          this.tableData = list;
        }
      });
    },
    // 分页事件
    changePage(page, filters, sorter) {
      this.pageBean.pageNum = page.current || 1;
      this.pageBean.pageSize = page.pageSize || 10;
      this.getData(this.pageBean.pageNum);
    },
    // 重置
    onReset() {
      this.params = {
        deptName: "",
        parentName: "",
        dataStatus: "",
      };
      this.deptName = "";
      this.checkValue = [];
      this.handleSearch();
    },
    // 菜单初始化
    getMenuInit() {
      let params = {
        data: {
          params: {},
        },
      };
      COMAPI.loadDeptDataAll(params, (callback) => {
        if (callback.status == "S" && callback.data) {
          if (Array.isArray(callback.data) && callback.data.length > 0) {
            let data = callback.data;
            this.treeData = this.getChildren(data);
            if (this.treeData && this.treeData.length > 0) {
              this.deptName = this.treeData[0].title;
              this.checkValue = [this.treeData[0].key];
              this.params = {};
              this.getData(1);
            }
          }
        }
      });
    },
    // 点击左侧机构
    onCheck(selectedKeys, info, data) {
      this.checkValue = selectedKeys;
      this.params = {};
      // this.params.id = selectedKeys;
      this.deptName = info.node.title;
      
      this.getData(1);
    },
    // 递归获取树形结构的子集
    getChildren(data) {
      let itemArr = [];
      data.forEach((item) => {
        let config = {
          title: item.name,
          key: item.id,
        };
        if (item.children) {
          config.children = this.getChildren(item.children);
        }
        itemArr.push(config);
      });

      return itemArr;
    },
    // 查看详情
    handleTableRow(flag, row, status) {
      this.modalFlag = flag;
      this.modalData = row || {};
      if (status == "ok") {
        this.getMenuInit();
      }
    },
    // 停用/撤回
    showSendConfirm(row) {
      let _this = this;
      this.$confirm({
        title: `是否确定${row.dataStatus == "0" ? "启用" : "停用"}当前的部门?`,
        content: (h) => <div style=""></div>,
        onOk() {
          const params = {
            data: {
              params: {
                id: row.id,
                dataStatus: row.dataStatus == "0" ? "1" : "0",
              },
            },
          };
          API.updatePubDeptStatus(params, (callback) => {
            if (callback.status == "S") {
              _this.$message.destroy();
              _this.$message.success(
                `${row.dataStatus == "0" ? "停用" : "启用"}成功`
              );
              _this.handleSearch();
            }
          });
        },
        onCancel() {
          console.log("Cancel");
        },
        class: "test",
      });
    },
    // 删除
    showDeletConfirm(row) {
      let _this = this;
      this.$confirm({
        title: "是否确定删除当前的部门?",
        content: (h) => <div style=""></div>,
        onOk() {
          const params = {
            data: {
              params: {
                id: row.id,
              },
            },
          };
          API.deletePubDeptInfo(params, (callback) => {
            if (callback.status == "S") {
              _this.$message.destroy();
              _this.$message.success("删除成功");
              _this.handleSearch();
            }
          });
        },
        onCancel() {
          console.log("Cancel");
        },
        class: "test",
      });
    },
  },
};
</script>
